<template>
  <el-dialog
    title="发布秀吧"
    :visible.sync="showEdit"
    width="45%"
    :append-to-body="true"
    @open="handleOpen"
    :modal-append-to-body="true"
    destroy-on-close
    @closed="handleClose"
    class="show-club-edit"
    :close-on-click-modal="false"
  >
    <el-form style="margin-top: -20px" ref="form" :model="form"  label-position="top" :rules="rules">
      <el-form-item label="请选择秀吧类型">
        <el-radio-group style="margin-top: -30px" size="mini" v-model="form.cover_type" @change="handleChangeCoverType($event)" :disabled="!isCreate">
          <el-radio-button  :label="0" border>图片</el-radio-button>
          <el-radio-button :label="1" border>视频</el-radio-button>
        </el-radio-group>
      </el-form-item>

      <el-row>
        <el-col :span="20">
          <el-form-item style="margin-top: -20px" class="show-file" label="请上传媒体文件">
            <love-element-upload
              style="margin-top: -10px"
              :list-type="uploadOption.listType"
              :drag="uploadOption.drag"
              :allow-type="uploadOption.allowType"
              :allow-size="uploadOption.allowSize"
              :disabled="uploadOption.disabled"
              :limit="uploadOption.limit"
              :multiple="uploadOption.multiple"
              :love-path="uploadOption.lovePath"
              :file-list="uploadOption.fileList"
              :accept="uploadOption.accept"
              :show-file-list="uploadOption.showFileList"
              @preview="onPreview"
              @remove="onRemove"
              @success="onSuccess" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="20">
          <el-form-item  label="请输入文字内容" prop="content">
            <el-input
              style="margin-top: -10px"
              type="textarea"
              :rows="4"
              :maxlength="200"
              show-word-limit
              placeholder="请输入文字内容"
              :autosize="{minRows: 4}"
              v-model="form.content">
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item class="axj-show-club-tags"  label="请选择文章标签" prop="main_tag_id">
            <div style="display: flex;margin-top: -10px">
              <el-tag @close="handleTagClose(x)" type="info" :key="x.value" closable size="mini" style="margin-right: 10px" v-for="x in checkedTags">
                #{{x.label}}
              </el-tag>
              <el-select @change="tagChange" v-model="checked" v-show="addNewTags" style="width: 100px" size="mini">
                <el-option v-for="tag in tagOption" :key="tag.value" :label="tag.label" :value="tag"></el-option>
              </el-select>
              <el-button @click="addNewTags=true" v-show="!addNewTags&&checkedTags.length<3" size="mini" type="test">+tag</el-button>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="medium" type="info" @click="handleClose">取消</el-button>
      <axj-button color="#00adb5" size="max" @click="handleSubmit">发布</axj-button>
    </div>
  </el-dialog>
</template>

<script>
import AxjButton from "../../../../components/axj-button/index";
import commonModels from '@/common/models/common-models'
const defaultForm = {
  thumb_url: '',
  cover_type: 0,
  video_url: '',
  thumb_sum: undefined,
  user_id: undefined,
  user_name: '',
  user_avatar: '',
  content: '',
  main_tag_id: undefined,
  school_id: undefined,
  status: 0,
  Tags:[],
  is_comment: 1,
  source_directory: '',
}
export default {
  name: "showClubEdit",
  components: {AxjButton},
  props: {
    show:{
      type:Boolean,
      default:false
    },
    isCreate: {
      type: Boolean,
      default: false
    },
    clubId:{
      type:Number,
      default:undefined
    }
  },
  watch:{
    show(v){
      this.showEdit=v
    }
  },
  data() {
    return {
      showEdit:false,
      checked:{},
      addNewTags:false,
      checkedTags:[],
      // 记录Show唯一id
      id: undefined,
      form: Object.assign({}, defaultForm),
      // 学校名称
      schoolName: '',
      // love element upload 上传文件组件参数
      uploadOption: {
        listType: "picture-card",
        drag: false,
        multiple: true,
        allowType: ["image/jpg", "image/jpeg", "image/png"],
        disabled: false,
        limit: 9,
        lovePath:{
          module: "extra/showclub",
          source_directory: "",  // this.uid + '_' + Date.parse(new Date()) / 1000
        },
        fileList: [],
        allowSize: 2,
        accept: 'image/*',
        showFileList: true
      },
      // fileList
      fileList: {
        image: [],
        video: [],
        remove: []
      },
      // tag option
      tagOption: [],
      // web view preview
      webPreview: false,
      // loading
      loading: false,
      // 数据验证
      rules: {
        title: [
          { required: true, message: 'Show标题不能为空', trigger: 'change' }
        ],
        content: [
          { required: true, message: 'Show的内容不能为空', trigger: 'change' }
        ],
        avatar: [
          { required: true, message: '请上传ShowLOGO', trigger: 'blur,change' }
        ],
        address: [
          { required: true, message: '请输入地址', trigger: 'change' }
        ]
      },
    }
  },
  methods: {
    handleOpen(){
      let user=this.$store.getters.getUser
      // 初始化一些公用数据
      this.initData()
      // 创建 sourceDirectory 规则为 [uuid_打开这页面的时间戳]
      this.uploadOption.lovePath.source_directory = user.extraShowClubUid + '_' + Date.parse(new Date()) / 1000
      // 判断编辑状态
      if (!this.isCreate) {
        // 编辑Show，使用route中的id获取form
        const id = this.clubId
        // data 中的 id，记录待使用
        this.id = parseInt(id)
        // 获取Show数据
        this.handleGetShowData(id)
      } else {
        // 发布Show form 为 default form
        this.form = Object.assign({}, defaultForm)
      }
    },
    tagChange(v){
      for(let x=0;x<this.tagOption.length;x++){
        if(this.tagOption[x].value===v.value){
          this.tagOption.splice(x,1)
        }
      }
      this.checkedTags.push(v)
      this.addNewTags=false
      this.checked=undefined
    },
    handleTagClose(v){
      for(let x=0;x<this.checkedTags.length;x++){
        if(this.checkedTags[x].value===v.value){
          this.checkedTags.splice(x,1)
          this.tagOption.push(v)
        }
      }
    },
    handleClose(){
      this.fileList={
        image: [],
        video: [],
        remove: []
      }
      this.uploadOption={
        listType: "picture-card",
        drag: false,
        multiple: true,
        allowType: ["image/jpg", "image/jpeg", "image/png"],
        disabled: false,
        limit: 9,
        lovePath:{
          module: "extra/showclub",
          source_directory: "",  // this.uid + '_' + Date.parse(new Date()) / 1000
        },
        fileList: [],
        allowSize: 2,
        accept: 'image/*',
        showFileList: true
      }
      this.checkedTags=[]
      this.form=Object.assign({}, defaultForm)
      this.$emit("close")
    },
    initData() {
      this.$api.axjExtracurricularApi.showClub.listShowClubTags()
        .then(res=> {
          this.tagOption = res.data.lists.map(item => {
            return { value: item.id, label: item.name };
          });
        })
    },
    handleGetShowData(id) {
      console.log(id)
      this.$api.axjExtracurricularApi.showClub.getShowClub(id)
        .then(res=> {
          const data = res.data
          // 常规数据
          this.form = Object.assign({},this.defaultForm, data)
          let tags=this.form.Tags
          tags.map(i=>{

            this.checkedTags.push({
              label:i.Tag.name,
              value:i.Tag.id
            })
            for(let x=0;x<this.tagOption.length;x++){
              if(this.tagOption[x].value===i.Tag.id){
                this.tagOption.splice(x,1)
              }
            }
          })

          // 去掉form中的多余属性
          this.$delete(this.form,'create_time')
          this.$delete(this.form,'update_time')
          this.$delete(this.form,'MainTag')
          this.$delete(this.form,'Count')
          this.$delete(this.form,'School')
          this.$delete(this.form,'Thumbs')
          this.$delete(this.form,'User')
          // 若数据库中已经存放了该Show的 source directory
          if (data.source_directory != '') {
            // uploadOption 中也使用该 source directory
            this.uploadOption.lovePath.source_directory = data.source_directory
          }
          // 学校名称
          if(data.school_id) {
            this.schoolName = data.School.name
          }
          // 判断封面类型
          if(data.cover_type){
            // 如果 thumb 中有数据
            if(data.Thumbs.length) {
              this.fileList.video = data.Thumbs.filter(item=> {
                if(item.type==='video') {
                  return item
                }
              })
            } else {
              // 否则使用正则表达式获取视频名称
              const regx = /([^/]+)$/
              const videoname = data.video_url.match(regx)
              // 是否有前缀
              let video = {
                name: videoname[1],
                url: data.video_url.indexOf('http')?data.video_url:this.$store.getters.getResourcePrefix.url + data.video_url,
                type: "video",
                status: "success"
              }
              this.fileList.video[0] = video
            }
            this.uploadOption.fileList = this.fileList.video
            this.handleChangeCoverType(this.form.cover_type)
          } else {
            // 图片
            this.fileList.image = data.Thumbs.map(item=> {
              let image = {
                id: item.id,
                name: item.name,
                url: item.url,
                type: item.type
              }
              if (!(item.url.indexOf('http') >= 0)) {
                image.url = this.$store.getters.getResourcePrefix.url + image.url
              }
              return image
            })
            this.uploadOption.fileList = this.fileList.image
          }
        })
    },
    onChangeSchool(val) {
      if(val) {
        this.form.school_id = val.value
        this.schoolName = val.label
      } else {
        this.form.school_id = null
        this.schoolName = ''
      }
    },
    onClearSelectSchool() {
      this.form.school_id = this.info.School.id
      this.schoolName = this.info.School.name
    },
    onPreview(file) {
      console.log(file)
      console.log(this.fileList)
    },
    onRemove(file, fileList) {
      // 若是有 id
      if(file.id){
        // 记录
        this.fileList.remove.push(file.id)
      }
      if(this.form.cover_type) {
        this.fileList.video = fileList.map(item => {
          if (typeof(item.response) != 'undefined') {
            return {
              uid: item.uid,
              name: item.response.old_name,
              url: item.response.url,
              status: item.status
            }
          }
          return item
        })
      } else {
        this.fileList.image = fileList.map(item => {
          if (typeof(item.response) != 'undefined') {
            return {
              uid: item.uid,
              name: item.response.old_name,
              url: item.response.url,
              status: item.status
            }
          }
          return item
        })
      }
    },
    onSuccess(response) {
      // 保存返回值
      const file = {
        uid: response.uid,
        name: response.old_name,
        url: response.url,
        status: "success"
      }
      // 若上传的文件为 MP4
      if(response.type==='video/mp4') {
        this.form.video_url = response.url
        this.fileList.video[this.fileList.video.length] = file
      } else {
        this.fileList.image[this.fileList.image.length] = file
      }
      console.log(response)
    },
    handleSubmit(status) {
      // 表单校验
      this.$refs['form'].validate(async (valid) => {
        if(valid) {
          // 补充表单信息
          this.form.status = status
          // uploadOption.lovePath.source_directory 中保存的为Show的 source_directory
          this.form.source_directory = this.uploadOption.lovePath.source_directory
          this.form.Tags=this.checkedTags.map((item)=>{
            let tag={tag_id:item.value}
            return tag
          })

          // 统计 thumb sum
          if(this.form.cover_type) {
            // 若是视频文件，封面则只有一个
            this.form.thumb_sum = 1
            // 设置封面图（使用ali-oss的参数获得视频的第0帧）
            this.form.thumb_url = this.form.video_url.slice(this.$store.getters.getResourcePrefix.url.length) + "?spm=a2c4g.11186623.2.1.yjOb8V&x-oss-process=video/snapshot,t_0,f_jpg"
            // 去掉视频文件前缀
            this.form.video_url = this.form.video_url.slice(this.$store.getters.getResourcePrefix.url.length)
          } else {
            // 图片文件
            this.form.thumb_sum = this.fileList.image.length
            this.form.thumb_url = this.fileList.image[0].url.slice(this.$store.getters.getResourcePrefix.url.length)
          }
          // 检验是否有删除掉的附件
          if(this.fileList.remove) {
            // 有删除附件记录则把需要删除的记录清空
            this.deleteAttachment()
          }
          // 若是用户没有选择学校则为默认
          this.form.school_id = this.form.school_id?this.form.school_id:this.$store.getters.getUser.schoolId
          // 创建Show时
          if(this.isCreate) {
            this.form.user_id = this.$store.getters.getUser.extraShowClubUid
            this.form.user_name = this.$store.getters.getUser.uname
            this.form.user_avatar = this.$store.getters.getUser.avatar
            this.id = await this.handleCreateShow(this.form)
            await this.handleCreateAttachment(this.id)
            this.$nextTick(()=> {
              this.checkedTags=[]
              this.form=Object.assign({}, defaultForm)
              commonModels.logs('extra','showClub','create-show-club-list-success!',0)
              this.$emit("created")
            })
          } else {
            this.$api.axjExtracurricularApi.showClub.deleteTagsRelation({
              where:JSON.stringify({
                article_id:this.clubId
              })
            })
            await this.handleCreateAttachment(this.id)
            await this.handleUpdateShow(this.form)
            await this.handleUpdateShowStatus(this.form)
            this.$nextTick(()=> {
              commonModels.logs('extra','showClub','update-show-club-list-success!',0)
              this.$emit("updated")
            })
          }
        }
      })
    },
    handleCloseSubmit() {
      // 取消修改
      this.$nextTick(()=> {
        this.$router.go(-1)
      })
    },
    handleCreateShow(form) {
      return new Promise((resolve, reject)=> {
        this.$api.axjExtracurricularApi.showClub.createShowClub(form)
          .then(res=> {
            this.$notify({
              message: form.status == 0 ? '保存成功!' : 'Show已成功发布!',
              type: 'success',
              duration: 2000
            })
            resolve(res.data.id)
          })
          .catch(err=> {
            this.$notify.error({
              message: 'Show发布失败，请重试!',
              duration: 2000
            })
            this.loading = false
            reject(err)
          })
      })
    },
    handleUpdateShow(form) {
      return new Promise((resolve, reject)=> {
        // 修改Show内容
        this.loading = true
        this.$api.axjExtracurricularApi.showClub.updateShowClub(form)
          .then(res=> {
            resolve(res)
          })
          .catch(err=> {
            reject(err)
          })
      })
    },
    handleUpdateShowStatus(form) {
      return new Promise((resolve, reject)=> {
        // 如果 thumb_sum 等从 非0 再修改为 0 的时候就需要用 where 修改了
        this.$api.axjExtracurricularApi.showClub.updateShowClub({
          id: form.id,
          where: JSON.stringify({
            status: form.status,
            is_comment: form.is_comment
          })
        })
          .then(res=> {
            this.$notify({
              message: form.status == 0 ? '保存成功!' : 'Show修改成功!',
              type: 'success',
              duration: 2000
            })
            this.loading = false
            resolve(res)
          })
          .catch(err=> {
            this.$notify.error({
              message: '修改Show失败，请重试!',
              duration: 2000
            })
            this.loading = false
            reject(err)
          })
      })
    },
    handleChangeCoverType(event) {
      // event 0 为图片类型 1 为视频类型
      if (event) {
        this.uploadOption.listType = "text"
        this.uploadOption.allowType = ["video/mp4"]
        this.uploadOption.drag = true
        this.uploadOption.disabled = false
        this.uploadOption.limit = 1
        this.uploadOption.fileList = this.fileList.video
        this.uploadOption.allowSize = 10
        this.uploadOption.accept = '.mp4'
        this.uploadOption.multiple = false
      } else {
        this.uploadOption.listType = "picture-card"
        this.uploadOption.allowType = ["image/jpg", "image/jpeg", "image/png"]
        this.uploadOption.drag = false
        this.uploadOption.disabled = false
        this.uploadOption.limit = 9
        this.uploadOption.fileList = this.fileList.image
        this.uploadOption.allowSize = 2
        this.uploadOption.accept = 'image/*'
        this.uploadOption.multiple = true
      }
    },
    handleCreateAttachment(id) {
      return new Promise((resolve, reject)=> {
        if(this.form.cover_type && this.fileList.video.length) {
          // 若是没有id
          if(!(this.fileList.video[0].id)){
            let video = {
              article_id: id,
              type: this.fileList.video[0].type?this.fileList.video[0].type:'video',
              name: this.fileList.video[0].name,
              user_id: this.$store.getters.getUser.extraShowClubUid,
              user_name: this.$store.getters.getUser.uname,
              user_avatar: this.$store.getters.getUser.avatar,
              status: 1,
              url: this.fileList.video[0].url.slice(this.$store.getters.getResourcePrefix.url.length)
            }
            this.createAttachment(video)
          }
          resolve()
        } else {
          if(this.fileList.image.length) {
            for(var i=0; i<this.fileList.image.length; i++) {
              // 若是没有 id，则创建，有的代表数据库中已有该文件
              if(!(this.fileList.image[i].id)){
                let image = {
                  article_id: id,
                  type: this.fileList.image[i].type?this.fileList.image[i].type:'image',
                  name: this.fileList.image[i].name,
                  user_id: this.$store.getters.getUser.extraShowClubUid,
                  user_name: this.$store.getters.getUser.uname,
                  user_avatar: this.$store.getters.getUser.avatar,
                  status: 1,
                  url: this.fileList.image[i].url.slice(this.$store.getters.getResourcePrefix.url.length)
                }
                this.createAttachment(image)
              }
            }
            resolve()
          } else {
            // 没有媒体文件
            reject()
          }
        }
      })
    },
    createAttachment(obj) {
      this.$api.axjExtracurricularApi.showClub.createShowClubAttachment(obj)
        .then(_ => {})
        .catch(_=> {})
    },
    deleteAttachment() {
      for(var i=0; i<this.fileList.remove.length; i++) {
        this.$api.axjExtracurricularApi.showClub.deleteShowClubAttachment(this.fileList.remove[i])
          .then(res=> {
            console.log("删除附件成功")
          })
          .catch(err=> {
            console.log("删除附件失败")
          })
      }
    },
  },
  computed: {
    // ...mapState('d2admin/user', [
    //   'info'
    // ]),
    // ...mapState('d2admin/bucket', [
    //   'resourcePrefix'
    // ])
  }
}
</script>

<style slot-scope lang="scss">
.show-club-edit .el-form-item{
 margin-bottom: 10px;
}
.show-club-edit{
  .axj-show-club-tags{
    .el-form-item__content{
      line-height: 10px;
    }
  }
  .el-radio-button__orig-radio:checked+.el-radio-button__inner {
    color: #FFF;
    background-color: #41555d;
    border-color: #41555d;
    -webkit-box-shadow: -1px 0 0 0 #41555d;
    box-shadow: -1px 0 0 0 #41555d;
  }
  .el-radio-button__orig-radio:checked+.el-radio-button__inner:hover{
    color: #FFF;
  }
  .el-tag--mini{
    height: 30px;
    padding: 0 5px;
    line-height: 30px;
  }
  .el-tag,.el-tag--info {
    background-color: #41555d;
    /* border-color: #e9e9eb; */
    color: #ffffff;
  }
  .el-upload-list--picture-card{
    .el-upload-list__item,is-success{
      height: 120px;
      width: 120px;
    }
  }
  .el-upload--picture-card{
    width: 120px;
    height: 120px;
    line-height: 125px;
  }
  .el-upload-list__item-thumbnail{
    height: 120px;
    width: 120px;
  }
  .el-upload-list__item-actions{
    width: 120px;
    height: 120px;

  }
  .el-upload-dragger{
    width: 240px;
    line-height: 0px;
    height: 160px;
    .el-icon-upload{
      width: 45px;
      height: 45px;
      margin: 30px 0 28px -20px;
    }
  }

  .dialog-footer{
    margin-top: -20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/axj-extracurricular/axj-show-club/action/showClubEdit.vue